(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tepela-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var link=event.target.closest('.tp-mobile-menu a,.tp-catalog-menu a');
  if(link){var menu=link.closest('details');if(menu){menu.removeAttribute('open');}}
  document.querySelectorAll('.tp-catalog-menu[open],.tp-mobile-menu[open]').forEach(function(menu){if(!menu.contains(event.target)){menu.removeAttribute('open');}});
});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.tp-catalog-menu[open],.tp-mobile-menu[open]').forEach(function(menu){menu.removeAttribute('open');menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();
})();
